import emptyState from './emptyState'
import { actionTypes } from './actions'
import { immutableSet } from '../../../utils/immutable'
import { IAction } from '../../../models/Action'
import { compose } from 'redux'

import {
  STATE_IDENTIFIER,
  LIST_IDENTIFIER,
  LOADER_IDENTIFIER,
} from './constants'
import { IResponseState } from '../../../components/Modals/ResponseModal/module/constants'
import { CHECK_PASSWORD_ERROR_CODES } from '../../../common/TwoFactorAuth/module/constants'

const { USERS, REQUEST_STATE, SELECTED_USER, PASSWORD_POLICY } =
  STATE_IDENTIFIER
  
//PASSWORD BLACKLIST - Start
const getResponsePayload = (payload: any) => {
  // Axios-style: action.payload.response.data
  // This app's fetch wrapper: action.payload.response (already the parsed body, not nested under .data)
  // HTTP success: action.payload
  return (
    payload?.response?.data ?? payload?.response ?? payload?.data ?? payload ?? {}
  )
}

const getResponseMessage = (payload: any): string | undefined => {
  const response = getResponsePayload(payload)

  const message =
    response?.responseCode ??
    response?.response ??
    response?.errorCode ??
    payload?.responseCode ??
    payload?.errorCode

  return typeof message === 'string' ? message : undefined
}

const getResponseState = (payload: any, isFailureAction = false) => {
  const response = getResponsePayload(payload)

  const isBusinessError =
    response?.result === false || response?.responseId === 500

  const isError = isFailureAction || isBusinessError
  const message = isError ? getResponseMessage(payload) : undefined

  console.log('[ChangePassword reducer] getResponseState', {
    isFailureAction,
    rawPayload: payload,
    extractedResponse: response,
    isBusinessError,
    message,
  })

  return {
    state: isError ? IResponseState.ERROR : IResponseState.SUCCESS,
    message,
  }
}

const setPendingResponse = (state: any) =>
  immutableSet([REQUEST_STATE], IResponseState.PENDING, state)

const setSuccessResponse = (state: any, action: any) =>
  immutableSet([REQUEST_STATE], getResponseState(action.payload), state)

const setFailureResponse = (state: any, action: any) =>
  immutableSet([REQUEST_STATE], getResponseState(action.payload, true), state)

//PASSWORD BLACKLIST - End


const ACTION_HANDLERS = {
  [actionTypes.USER_REQUEST_CHANGE_PASSWORD]: (state: any, action: any) =>
    immutableSet([USERS, LOADER_IDENTIFIER], true, state),
  [actionTypes.USER_REQUEST_CHANGE_PASSWORD_SUCCESS]: (
    state: any,
    action: any
  ) => {
    let mappedResponse = [] as any[]
    action.payload.length > 0 &&
      action.payload.forEach((data: any) => {
        if (data.changePwdAllowed === true) {
          mappedResponse.push(data)
        }
      })
    return compose(
      immutableSet([USERS, LIST_IDENTIFIER], mappedResponse),
      immutableSet([USERS, LOADER_IDENTIFIER], false)
    )(state)
  },
  [actionTypes.USER_REQUEST_CHANGE_PASSWORD_FAILURE]: (
    state: any,
    action: any
  ) =>
    compose(
      immutableSet([USERS, LIST_IDENTIFIER], []),
      immutableSet([USERS, LOADER_IDENTIFIER], false)
    )(state),
  [actionTypes.PASSWORD_POLICY_REQUEST_SUCCESS]: (state: any, action: any) =>
    immutableSet([PASSWORD_POLICY], action.payload, state),
  [actionTypes.PASSWORD_POLICY_REQUEST_FAILURE]: (state: any, action: any) =>
    immutableSet([PASSWORD_POLICY], {}, state),

[actionTypes.CHANGE_PASSWORD_REQUEST]: (state: any) =>
  setPendingResponse(state),

[actionTypes.CHANGE_PASSWORD_REQUEST_SUCCESS]: (state: any, action: any) =>
  setSuccessResponse(state, action),

[actionTypes.CHANGE_PASSWORD_REQUEST_FAILURE]: (state: any, action: any) =>
  setFailureResponse(state, action),

[actionTypes.VERIFY_CHANGE_SEC_QUESTIONS]: (state: any) =>
  setPendingResponse(state),

[actionTypes.VERIFY_CHANGE_SEC_QUESTIONS_SUCCESS]: (
  state: any,
  action: any
) => setSuccessResponse(state, action),

[actionTypes.VERIFY_CHANGE_SEC_QUESTIONS_FAILURE]: (
  state: any,
  action: any
) => setFailureResponse(state, action),

  [actionTypes.SET_USER_SELECTED]: (state: any, action: any) =>
    immutableSet([SELECTED_USER], action.payload, state),

[actionTypes.VERIFY_CHANGE_UIGP_OTP]: (state: any) =>
  setPendingResponse(state),

[actionTypes.VERIFY_CHANGE_UIGP_OTP_SUCCESS]: (
  state: any,
  action: any
) => setSuccessResponse(state, action),

[actionTypes.VERIFY_CHANGE_UIGP_OTP_FAILURE]: (
  state: any,
  action: any
) => setFailureResponse(state, action),

[actionTypes.VERIFY_CHANGE_ARCOT_OTP]: (state: any) =>
  setPendingResponse(state),

[actionTypes.VERIFY_CHANGE_ARCOT_OTP_SUCCESS]: (
  state: any,
  action: any
) => setSuccessResponse(state, action),

[actionTypes.VERIFY_CHANGE_ARCOT_OTP_FAILURE]: (
  state: any,
  action: any
) => setFailureResponse(state, action),

  [actionTypes.RESET_STATE_CHANGE_PASSWORD]: (state: any, action: any) =>
    emptyState,

[actionTypes.FORCED_CHANGE_PWD]: (state: any) =>
  setPendingResponse(state),

[actionTypes.FORCED_CHANGE_PWD_SUCCESS]: (
  state: any,
  action: any
) => setSuccessResponse(state, action),

[actionTypes.FORCED_CHANGE_PWD_FAILURE]: (
  state: any,
  action: any
) => setFailureResponse(state, action),

}

export default function communicationReducer(
  state = emptyState,
  action: IAction
) {
  if (
    action &&
    action.type === '@@router/LOCATION_CHANGE' &&
    action.payload.location.pathname === '/welcome'
  ) {
    return emptyState
  }
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}
